import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import { storyblokEditable } from '@storyblok/react';
import React, { useState } from 'react';

import { textColors, yellow } from '../../../../styles/mui/colors';
import StoryblokRichText from '../StoryblokRichText';

/**
 * Storyblok component: AccordionItem
 * @param {object} props
 * @param {object} props.blok
 * @param {number} props.index
 */
const StoryblokAccordionItem = ({ blok, index }) => {
  const { title = '', text = {}, general_component = {} } = blok;
  const [expanded, setExpanded] = useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const TitleComponent =
    typeof general_component === 'string' && general_component.trim()
      ? general_component
      : general_component && typeof general_component === 'object' && general_component.type
      ? general_component.type
      : 'p';

  return (
    <Accordion
      expanded={expanded === `panel${index}`}
      onChange={handleChange(`panel${index}`)}
      {...storyblokEditable(blok)}
    >
      <AccordionSummary
        aria-controls={`panel${index}bh-content`}
        expandIcon={
          <ExpandMoreIcon
            sx={{
              color: `${expanded === `panel${index}` ? yellow.main : textColors.primaryText}`,
            }}
          />
        }
        id={`panel${index}bh-header`}
      >
        <Typography component={TitleComponent} variant="body1">
          {title}
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <StoryblokRichText
          blok={{
            general: {
              content: text,
            },
          }}
        />
      </AccordionDetails>
    </Accordion>
  );
};

export default StoryblokAccordionItem;
